import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useWebhookMutations from "../../datahooks/useWebhookMutations";

import type { Webhook } from "../../types";

interface DeleteWebhookProps {
  webhook: Webhook;
  onBack: () => void;
  onClose: () => void;
}

export default function DeleteWebhook({
  webhook: { id, name },
  onBack,
  onClose,
}: DeleteWebhookProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteWebhook, isDeletingWebhook } = useWebhookMutations();

  function onDelete() {
    deleteWebhook({ webhookId: id }).then(onClose);
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Delete webhook"
        subtitle={
          <>
            Are you sure you want to delete{" "}
            <span className="break-words font-semibold text-black-950">
              {name}
            </span>
            ?
          </>
        }
      />
      <Footer className="justify-end">
        <Button
          variant="secondary-black"
          onClick={onBack}
          disabled={isDeletingWebhook}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          isLoading={isDeletingWebhook}
          onClick={onDelete}
        >
          Delete
        </Button>
      </Footer>
    </>
  );
}
